module.exports = __webpack_public_path__ + "img/mexico.7dfe2adf.svg";